<template>
    <div>
        <div class="card">
            <div class="card-body">
                <div class="card-content">
                    <div class="text-center">
                        <div
                            class="spinner-border text-primary"
                            role="status"
                            v-if="loading"
                            style="opacity: .6"
                        >
                            <span class="sr-only">{{$t('Loading...')}}</span>
                        </div>
                    </div>
                    <p class="text-center mb-0" v-if="!contractsData.length && !loading">{{$t('No Contracts Found...')}}</p>
                    <div class="table-responsive" v-if="contractsData.length">
                    <table class="table contracts-table nowrap scroll-horizontal" :aria-label="$t('users_arial_label_user_contract_list')">
                        <thead>
                            <tr>
                                <th>{{$t('Name')}}</th>
                                <th>{{$t('Country')}}</th>
                                <th>{{$t('Status')}}</th>
                                <th>{{$t('Landlord')}}</th>
                                <th>{{$t('Tenant')}}</th>
                                <th>{{$t('Rent Start')}}</th>
                                <th>{{$t('Duration')}}</th>
                                <th>{{$t('Property')}}</th>
                                <th>{{$t('Created At')}}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(contract, index) in contractsData" :key="index">
                                <td class="contractName capitalize">
                                    {{ contract.name }}
                                    <br>
                                    <a @click="onClickContractDetails(contract.id)" style="margin-top: 5px;">
                                        {{$t('View Details')}}
                                    </a>
                                </td>
                                <td>{{ countryName(contract.country) }}</td>
                                <td class="capitalize">
                                    <span v-if="contract.status == 'sent'">
                                     <em class="bx bxs-circle info font-small-1 mr-50"></em> {{ contract.status }}
                                    </span>
                                    <span v-if="contract.status == 'active'">
                                     <em class="bx bxs-circle success font-small-1 mr-50"></em> {{ contract.status }}
                                    </span>
                                    <span v-if="contract.status == 'expired'">
                                     <em class="bx bxs-circle danger font-small-1 mr-50"></em> {{ contract.status }}
                                    </span>
                                    <span v-if="contract.status == 'void'">
                                     <em class="bx bxs-circle light-secondary font-small-1 mr-50"></em> {{ contract.status }}
                                    </span>
                                </td>
                                <td>{{ (contract.landlord.name) ? contract.landlord.name : '-' }}</td>
                                <td>{{ (contract.tenants[0].name) ? contract.tenants[0].name : '-' }}</td>
                                <td>{{ contract.data.rentStart.split("T")[0] }}</td>
                                <td>{{ contract.data.contractDuration }} months</td>
                                <td>{{ (contract.property.name) ? contract.property.name : '-' }}</td>
                                <td>{{ contract.createdAt.split("T")[0] }}</td>
                            </tr>
                        </tbody>
                    </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { getCountryName } from '@/app-assets/js/get-countries.js'
    export default {
        props: ["contracts"],

        data() {
            return {
                loading: true,
                contractsData: []
            }
        },

        methods: {
            onClickContractDetails(contractId){
                window.open(`/contracts/details/${contractId}`,"_blank")
            },
            getContractsData() {
                let urls = [];

                if(!this.contracts.length) this.loading = false;

                this.contracts.map(x => urls.push(this.$apiCall.get(`/v1/contracts/contract/${x}`)));

                Promise.all(urls)
                .then(response => {
                    this.loading = false;
                    response.map(x => this.contractsData.push(x.data));
                    this.initDataTable();
                })
                .catch(error => {
                    console.log(error);
                })
            },

            initDataTable() {
                setTimeout(function () {
                    $(".contracts-table").DataTable({
                        "scrollX": true,
                        "bLengthChange": false,
                        "bFilter": false,
                        "order": []
                    });
                }, 100);
            },

            countryName(element){
                if(element){
                    return getCountryName(element.toUpperCase())
                }
            }
        },

        mounted() {
            this.getContractsData();
        }
    }
</script>

<style scoped>
  a:not([href]):not([tabindex]) {
      color: #5A8DEE;
      text-decoration: none;
      cursor: pointer;
  }
  a:not([href]):not([tabindex]):hover{
    color: #175ee4;
  }
</style>